import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const UserTabs: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isSlideBoxOpen, setIsSlideBoxOpen] = useState(false);

  // Get user type from session storage
  const userType = localStorage.getItem("frontendUserType");

  // Only show Post Land & My Lands if user type is 1 or 2
  const canManageLands = userType === "1" || userType === "2";

  const toggleSlideBox = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsSlideBoxOpen(!isSlideBoxOpen);
  };

  return (
    <>
      {/* Mobile View */}
      <div className="d-block d-sm-none">
        <a
          href="#"
          className="btn account-menu btn-block d-flex justify-content-between"
          id="toggleBtn"
          onClick={toggleSlideBox}
        >
          Account Menu <i className="bi bi-caret-down-fill"></i>
        </a>
        <div id="slideBox" className={`slide-toggle mt-3 ${isSlideBoxOpen ? "show" : ""}`}>
          <ul className="nav nav-tabs" role="tablist">
            <li
              role="presentation"
              className={currentPath === "/authuser/dashboard" ? "active" : ""}
            >
              <Link to="/authuser/dashboard" className="sec1y">
                <span>Dashboard</span>
              </Link>
            </li>
            <li
              role="presentation"
              className={currentPath === "/authuser/profile" ? "active" : ""}
            >
              <Link to="/authuser/profile">
                <span>Profile</span>
              </Link>
            </li>
            {canManageLands && (
              <li
                role="presentation"
                className={currentPath === "/authuser/Post-Land" ? "active" : ""}
              >
                <Link to="/authuser/Post-Land">
                  <span>Post Land</span>
                </Link>
              </li>
            )}
            {canManageLands && (
              <li
                role="presentation"
                className={currentPath === "/authuser/My-Lands" ? "active" : ""}
              >
                <Link to="/authuser/My-Lands">
                  <span>My Lands</span>
                </Link>
              </li>
            )}
            <li
              role="presentation"
              className={currentPath === "/authuser/change-password" ? "active" : ""}
            >
              <Link to="/authuser/change-password">
                <span>Change Password</span>
              </Link>
            </li>
            <li
              role="presentation"
              className={currentPath === "/authuser/enquiries" ? "active" : ""}
            >
              <Link to="/authuser/enquiries">
                <span>My Enquiries</span>
              </Link>
            </li>
            {!canManageLands && (
              <li
                role="presentation"
                className={currentPath === "/authuser/activities" ? "active" : ""}
              >
                <Link to="/authuser/activities">
                  <span>My Activities</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>

      {/* Desktop View */}
      <div className="d-none d-sm-block">
        <ul className="nav nav-tabs" role="tablist">
          <li
            role="presentation"
            className={currentPath === "/authuser/dashboard" ? "active" : ""}
          >
            <Link to="/authuser/dashboard" className="sec1y">
              <span>Dashboard</span>
            </Link>
          </li>
          <li
            role="presentation"
            className={currentPath === "/authuser/profile" ? "active" : ""}
          >
            <Link to="/authuser/profile">
              <span>Profile</span>
            </Link>
          </li>
          {canManageLands && (
            <li
              role="presentation"
              className={currentPath === "/authuser/Post-Land" ? "active" : ""}
            >
              <Link to="/authuser/Post-Land">
                <span>Post Land</span>
              </Link>
            </li>
          )}
          {canManageLands && (
            <li
              role="presentation"
              className={currentPath === "/authuser/My-Lands" ? "active" : ""}
            >
              <Link to="/authuser/My-Lands">
                <span>My Lands</span>
              </Link>
            </li>
          )}
          <li
            role="presentation"
            className={currentPath === "/authuser/change-password" ? "active" : ""}
          >
            <Link to="/authuser/change-password">
              <span>Change Password</span>
            </Link>
          </li>
          <li
            role="presentation"
            className={currentPath === "/authuser/enquiries" ? "active" : ""}
          >
            <Link to="/authuser/enquiries">
              <span>My Enquiries</span>
            </Link>
          </li>
          {!canManageLands && (
            <li
              role="presentation"
              className={currentPath === "/authuser/activities" ? "active" : ""}
            >
              <Link to="/authuser/activities">
                <span>My Activities</span>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default UserTabs;